import React from 'react';
import { Wrench, ImageIcon, ChevronDown, Sparkles, Timer } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const tools = [
  {
    label: 'Email Builder',
    url: 'https://ad-email-lab-builder.lovable.app/',
    icon: Wrench,
  },
  {
    label: 'Image Editor',
    url: 'https://ad-email-image-editor.lovable.app/',
    icon: ImageIcon,
  },
  {
    label: 'Email Countdown Generator',
    url: 'https://email-timer-craft.lovable.app/',
    icon: Timer,
  },
];

const ToolsDropdown: React.FC = () => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="group relative inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold border-2 border-primary/30 bg-gradient-to-r from-white to-blue-50 hover:from-primary/5 hover:to-primary/10 hover:border-primary/50 transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-primary/20 rounded-xl overflow-hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-primary/0 via-primary/5 to-primary/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out"></div>
          <div className="relative z-10 p-1 bg-primary/10 rounded-lg group-hover:bg-primary/20 transition-colors duration-300">
            <Sparkles className="h-3 w-3 text-primary" />
          </div>
          <span className="relative z-10 text-secondary group-hover:text-primary transition-colors duration-300 text-center leading-tight whitespace-nowrap">
            Tools Made by Me
          </span>
          <ChevronDown className="relative z-10 h-3 w-3 text-primary transition-transform duration-300 group-data-[state=open]:rotate-180" />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 ease-in-out"></div>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="w-56 border-2 border-primary/20 shadow-xl shadow-primary/10 rounded-xl bg-white"
      >
        {tools.map(({ label, url, icon: Icon }) => (
          <DropdownMenuItem
            key={label}
            onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
            className="cursor-pointer gap-2 px-3 py-2.5 text-secondary hover:!bg-primary/5 hover:!text-primary focus:!bg-primary/5 focus:!text-primary rounded-lg font-medium"
          >
            <div className="p-1 bg-primary/10 rounded-md">
              <Icon className="h-3.5 w-3.5 text-primary" />
            </div>
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ToolsDropdown;